import React from "react";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import InputComponent from "../_common/inputComponent";
import PaginationOwn from "../_common/ownPagination";

const ReportUserTable = (props) => {
  const {
    searchFunc,
    searchVal,
    setSearchVal,
    allReport,
    reportData,
    sortObj,
    arraySorting,
    totalStats,
    pageSize,
    changePageSize,
    goToPage,
    totalCount,
    currentPage,
    applicationType,
  } = props;

  const { t } = useTranslation();

  const headers = [
    { label: t("admin.reports.telephone"), key: "userMobile" },
    { label: t("admin.reports.userZone"), key: "zone" },
    { label: t("admin.reports.totalProductsCollected"), key: "count" },
  ];

  return (
    <div className="container-fluid">
      <div className="row form-report my-2">
        <div className="col-12">
          <div className="row admin-controls">
            {/* Search Form */}
            <form
              onSubmit={(ev) => searchFunc?.(ev, searchVal)}
              className="col-12 col-lg-6 admin-search"
            >
              <div className="search-wrapper">
                <InputComponent
                  placeholder={t("admin.reports.searchUser")}
                  label={t("admin.reports.searchUser")}
                  type="text"
                  name="search"
                  theme="admin"
                  value={searchVal}
                  handleCallback={(val) => setSearchVal?.(val)}
                />
              </div>

              <button type="submit" className="btn secondary-btn">
                {t("common.go")}
              </button>
            </form>

            {/* Actions & Content Section */}
            <div className="row">
              {/* CSV Download Button */}
              <div className="col-12 mb-3 mt-4">
                <CSVLink
                  className="btn secondary-btn modal-btn"
                  data={allReport}
                  filename={"user-report.csv"}
                  headers={headers}
                >
                  {t("common.downloadCsv")}
                </CSVLink>
              </div>

              {/* Data Table */}
              <div className="report-table-wrapper col-lg-8 col-md-12">
                <p className="report-type fs-4">
                  {t("admin.reports.condomsPerUser")}
                </p>

                <div className="table-wrapper-scroll-y table-scrollbar">
                  <div className="table-responsive table-own">
                    <table className="table table-hover table-admin">
                      <thead className="table-head">
                        <tr>
                          <th
                            className={`sort-header cursor ${
                              sortObj?.sortVal === "userMobile" ? "active" : ""
                            } ${sortObj?.sortType ? "aesc" : "desc"}`}
                            onClick={() => arraySorting?.("userMobile")}
                          >
                            <span>{t("admin.reports.telephone")}</span>
                            {sortObj?.sortType === "aesc" && (
                              <i className="fas fa-caret-down ms-1"></i>
                            )}
                            {sortObj?.sortType === "desc" && (
                              <i className="fas fa-caret-up ms-1"></i>
                            )}
                          </th>

                          <th
                            className={`sort-header cursor ${
                              sortObj?.sortVal === "zone" ? "active" : ""
                            } ${sortObj?.sortType ? "aesc" : "desc"}`}
                            onClick={() => arraySorting?.("zone")}
                          >
                            <span>{t("admin.reports.userZone")}</span>
                            {sortObj?.sortType === "aesc" && (
                              <i className="fas fa-caret-down ms-1"></i>
                            )}
                            {sortObj?.sortType === "desc" && (
                              <i className="fas fa-caret-up ms-1"></i>
                            )}
                          </th>

                          <th
                            className={`sort-header cursor ${
                              sortObj?.sortVal === "count" ? "active" : ""
                            } ${sortObj?.sortType ? "aesc" : "desc"}`}
                            onClick={() => arraySorting?.("count")}
                          >
                            <span>
                              {t("admin.reports.totalProductsCollected")}
                            </span>
                            {sortObj?.sortType === "aesc" && (
                              <i className="fas fa-caret-down ms-1"></i>
                            )}
                            {sortObj?.sortType === "desc" && (
                              <i className="fas fa-caret-up ms-1"></i>
                            )}
                          </th>
                        </tr>
                      </thead>

                      <tbody className="table-body">
                        {reportData?.map((data, index) => (
                          <tr key={data?.userMobile || index}>
                            <td>{data?.userMobile}</td>
                            <td>{data?.zone}</td>
                            <td>{data?.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination */}
                {reportData?.length > 0 && (
                  <div className="pt-3">
                    <PaginationOwn
                      pageSize={pageSize}
                      changePageSize={changePageSize}
                      goToPage={goToPage}
                      totalCount={totalCount}
                      currentPage={currentPage}
                      applicationType={applicationType}
                      paginationType="report"
                    />
                  </div>
                )}
              </div>

              {/* Stats Panel */}
              <div className="reports-stats-wrapper col-lg-4 col-md-12">
                <p className="report-type fs-4">
                  {t("admin.reports.totalsPerDateRange")}
                </p>

                <div className="reports-stats">
                  <ul className="list-unstyled">
                    <li className="list-group-item list-group-item-success d-flex justify-content-between report-data">
                      <span>{t("admin.reports.storesUsed")}</span>
                      <span>{totalStats?.storesUesd}</span>
                    </li>

                    <li className="list-group-item list-group-item-primary d-flex justify-content-between report-data">
                      <span>{t("admin.reports.kioskUsed")}</span>
                      <span>{totalStats?.ivtsUesd}</span>
                    </li>

                    <li className="list-group-item list-group-item-warning d-flex justify-content-between report-data">
                      <span>{t("admin.reports.collections")}</span>
                      <span>{totalStats?.totalCollections}</span>
                    </li>

                    <li className="list-group-item list-group-item-primary d-flex justify-content-between report-data">
                      <span>{t("admin.reports.usersAdded")}</span>
                      <span>{totalStats?.newUsers}</span>
                    </li>

                    <li className="list-group-item list-group-item-danger d-flex justify-content-between report-data">
                      <span>{t("admin.reports.usersActive")}</span>
                      <span>{totalStats?.activeUsers}</span>
                    </li>

                    <li className="list-group-item list-group-item-success d-flex justify-content-between report-data">
                      <span>{t("admin.reports.totalUsersAllTime")}</span>
                      <span>{totalStats?.totalUsers}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportUserTable;